import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const fetchFruits = () => client.get("/fruits").then((r) => r.data);
export const fetchFruit = (slug) => client.get(`/fruits/${slug}`).then((r) => r.data);
export const fetchCalendar = () => client.get("/calendar").then((r) => r.data);
export const fetchStats = () => client.get("/stats").then((r) => r.data);
export const fetchInSeason = (month) =>
  client.get("/in-season", { params: month ? { month } : {} }).then((r) => r.data);
export const submitEnquiry = (payload) =>
  client.post("/enquiries", payload).then((r) => r.data);
